// Entry point for the build script in your package.json
import * as Lexxy from "@37signals/lexxy"
import { TextAlignExtension } from "dlnk_ui/dlnk_text_align_extension"

// Lexxy.configure doit être appelé immédiatement après l'import : les éléments
// <lexxy-editor> sont enregistrés à la fin du call stack courant (cf. doc).
Lexxy.configure({
  global: { extensions: [ TextAlignExtension ] }
})

import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"
import "@rails/actiontext"
